import { Injectable } from '@nestjs/common';
import { Notification } from '../models/notification';

@Injectable()
export abstract class NotificationDataAccessService {
  abstract sendMessage(notification: Notification): void;
}
